import { Flag } from "./flag";

// HOW TO ADD FEATURE FLAGS

// 1. Add a new variable to your .env file. The variable name needs
// to start with the value defined on FLAG_PREFIX at flag.ts

// 2. Add a const here with the same name you made on your .env, without the prefix.
// The const should hold a new flag with the correct flag type (boolean, string or number).

// 3. DON'T FORGET THAT THE .env CONST NEEDS A FLAG PREFIX
export const PDF_DOWNLOAD = Flag.Boolean("PDF_DOWNLOAD");
export const DISPLAY_DEVICE_CREATION = Flag.Boolean("DISPLAY_DEVICE_CREATION");
export const RETROSPECTIVA = Flag.Boolean("RETROSPECTIVA");
export const WIFI_QUALITY = Flag.Boolean("WIFI_QUALITY");
export const WORKING_HOURS = Flag.Boolean("WORKING_HOURS");
